export default ({ index, name }) => `readingRanges[${index}][${name}]`
